/* import __COLOCATED_TEMPLATE__ from './entries-table-teams-details-row.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class EntriesTableTeamsDetailsRowComponent extends Component 
{
	@service store;
	
	@tracked addingTeamMember = false;
	@tracked enteredBib = null;
	@tracked enteredTeamOrder = null;
	
	// Same behavior as entries-table-details-row's clearIntermediate, but the
	// team table spans multiple entries, so revert from the record's own
	// previous association rather than a single entry argument.
	@action
	async clearIntermediate(intermediateTimingRecord)
	{
		const previousEntry = intermediateTimingRecord.EntryId;
		intermediateTimingRecord.EntryId = null;

		try
		{
			await intermediateTimingRecord.save();
		}
		catch (error)
		{
			alert(error);
			intermediateTimingRecord.EntryId = previousEntry;
		}
	}

	@action
	async saveTeamOrder(entry)
	{
		entry.teamOrder = entry.get('tempTeamOrder');
		try
		{
			await entry.save();
		}
		catch (error)
		{
			alert(error);
			entry.rollbackAttributes();
		}
		entry.set('editingTeamOrder',false);
		
		entry.set('tempTeamOrder',entry.teamOrder);
	}
	
	@action
	cancelTeamOrder(entry)
	{
		entry.set('editingTeamOrder',false);
		entry.set('tempTeamOrder',entry.teamOrder);
	}
	
	@action
	toggleEditingTeamOrder(entry)
	{
		entry.set('editingTeamOrder',!entry.get('editingTeamOrder'));
		entry.set('tempTeamOrder',entry.teamOrder);
	}
	
	@action
	async deleteTeamMember(entry)
	{
		const oldTeamId = entry.TeamId.content;
		const oldTeamOrder = entry.teamOrder;
		entry.TeamId = null;
		entry.teamOrder = null;
		
		try
		{
			await entry.save();
		}
		catch (error)
		{
			alert(error);
			entry.teamOrder = oldTeamOrder;
			entry.TeamId = oldTeamId;
		}
	}
	
	@action
	addTeamMember()
	{
		this.enteredBib = null;
		this.addingTeamMember = true;
	}
	
	@action
	cancelAddTeamMember()
	{
		this.enteredBib = null;
		this.addingTeamMember = false;
	}
	
	@action
	async bibEntered(value)
	{
		var bib = this.enteredBib;
		var team = this.args.team;
		
		
		const entries = await team.get('EventId.entries')
		for(const entry of entries)
		{
			if(entry.bib == bib)
			{
				const foundEntryTeam = await entry.get('TeamId');
				if(foundEntryTeam != null)
				{
					alert("Bib already associated with a team");
				}
				else
				{
					entry.TeamId = team;
					try
					{
						await entry.save();
					}
					catch (error)
					{
						alert(error);
						entry.TeamId = null;
					}
					this.enteredBib = null;
					this.addingTeamMember = false;
				}
			}
		}
	}
}  